import { useEffect, useState } from 'react'
import { imageUrl } from 'app/frontend/base/helpers'

type Props = {
  spellId: number
  size?: 'custom' | 'tiny' | 'small' | 'medium' | 'large'
  title?: string
  className?: string
}

const SpellIcon = ({ spellId, size = 'custom', title, className }: Props) => {
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    setHidden(false)
  }, [spellId])

  const sizeStyles = {
    custom: '',
    tiny: 'w-3 h-3 border-0 min-w-3 min-h-3',
    small: 'w-4 h-4 border-0 min-w-4 min-h-4',
    medium: 'w-6 h-6 border min-w-6 min-h-6',
    large: 'w-8 h-8 border-2 min-w-8 min-h-8',
  }[size]

  const iconStyles =
    size === 'custom'
      ? className
      : `${sizeStyles} border-[#666] rounded-md ${className ?? ''}`

  if (!spellId || hidden) {
    return <div className={iconStyles} />
  }

  return (
    <img
      className={iconStyles}
      title={title}
      alt={title}
      src={imageUrl(`icons/${spellId}.jpg`)}
      onError={() => setHidden(true)}
    />
  )
}

export default SpellIcon
